import { ReactNode } from "react";
import { Box } from "@mui/material";
import { Navigation } from "@finpay-development/shared-platform/lib/esm/security/model/navigation";
import  DesktopHeader from "./desktop-header";
import  MobileHeader from "./mobile-header";

interface HeaderProps {
  showLinks?: boolean;
  subNav?: Navigation[];
  /** Rendered in the mobile (hamburger) header only; desktop keeps the
      button in the sub-navigation strip. */
  paymentHub?: ReactNode;
}

function FppHeader(props: HeaderProps) {

  return (
    <>   
    <Box display={{ xs: 'none', md: 'block' }}>
        <DesktopHeader {...props}/>
    </Box>
    <Box display={{ xs: 'block', md: 'none' }}>
      <MobileHeader {...props}/>
    </Box>
    </>
  );
}

export default FppHeader;
